import React from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import { css } from 'emotion';
import { RouteComponentProps } from 'react-router-dom';

import { CustomAxios } from '../../../redux/axios/axios';
import { expressApiKey, standardApiKey } from '../../../config';
import { PaymentPageContainer } from '../../payment-page-container/payment-page.container';
import LoadingSpinner from '../../../images/loading-spinner.gif';

interface Props extends RouteComponentProps<{ id: string }> {}

export const loader = css`
  position: relative;
  top: 213px;
  width: 150px;
  display: block;
  margin: auto;
`;

enum ProcessorType {
  Express = 'EXPRESS',
  Standard = 'STANDARD',
}

export const StripeWrapper = (props: Props) => {
  const [loaded, setLoaded] = React.useState(false);
  const [processorType, setProcessorType] = React.useState<ProcessorType>(
    ProcessorType.Standard
  );
  const uniqueLink = props.match.params.id;

  React.useEffect(() => {
    CustomAxios.get(`/v1/invoices/${uniqueLink}/processor-type`).then(
      (result) => {
        setProcessorType(result.data.data);
        setLoaded(true);
      },
      (error) => {
        console.error(error);
        setProcessorType(ProcessorType.Standard);
        setLoaded(true);
      }
    );
  }, [uniqueLink]);

  if (!loaded) {
    return <img src={LoadingSpinner} className={loader} alt="Loading" />;
  } else {
    const apiKey =
      processorType === ProcessorType.Express ? expressApiKey : standardApiKey;
    return (
      <StripeProvider apiKey={apiKey}>
        <Elements>
          <PaymentPageContainer uniqueLink={uniqueLink} />
        </Elements>
      </StripeProvider>
    );
  }
};
